/**
 * Role Label Utilities
 * Convert role strings to human-readable display labels
 */

/**
 * Get human-readable label for a role
 */
export function getRoleLabel(role: string): string {
  const labels: Record<string, string> = {
    support_staff: 'Support Staff',
    teacher: 'Teacher',
    admin: 'Administrator',
    super_admin: 'Super Administrator',
    parent: 'Family Member',
  };

  return labels[role] || role;
}

/**
 * Get short role description
 */
export function getRoleDescription(role: string): string {
  const descriptions: Record<string, string> = {
    support_staff: 'Can log location-based behaviors',
    teacher: 'Can mark classroom behaviors and attendance',
    admin: 'Can manage users, settings, and access all features',
    super_admin: 'System administrator with cross-tenant access',
    parent: 'Can view student information via family portal',
  };

  return descriptions[role] || '';
}
